/* =====================================================
   cart-v2.js — Muyu Cart Page JavaScript
   All Liquid data comes via window.MUYU_CART
   ===================================================== */

(function() {
  'use strict';

  var MC = window.MUYU_CART || {};
  var CHECKOUT_URL = MC.CHECKOUT_URL || 'https://checkout.muyusleep.com';
  var COMPARE_PRICES = MC.COMPARE_PRICES || {};
  var CHECKOUT_SUMMARY = MC.CHECKOUT_SUMMARY || {};

  /* ---------- formatMoney ---------- */
  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return withCommas + '.' + decPart + 'TL';
  }
  window.formatMoney = formatMoney;

  /* ---------- selectPayment ---------- */
  function selectPayment(type) {
    var tabs = document.querySelectorAll('.cart-payment-tab');
    tabs.forEach(function(tab) {
      if (tab.dataset.payment === type) {
        tab.classList.add('is-active');
      } else {
        tab.classList.remove('is-active');
      }
    });

    var havaleRow = document.getElementById('havale-row');
    if (havaleRow) havaleRow.style.display = type === 'havale' ? 'flex' : 'none';

    var totalEl = document.getElementById('total-display');
    if (totalEl) totalEl.textContent = type === 'havale' ? formatMoney(parseInt(totalEl.dataset.havale)) : formatMoney(parseInt(totalEl.dataset.card));

    var savingsEl = document.getElementById('savings-display');
    if (savingsEl) savingsEl.textContent = '-' + (type === 'havale' ? formatMoney(parseInt(savingsEl.dataset.havale)) : formatMoney(parseInt(savingsEl.dataset.card)));

    // Sticky bar fiyatını güncelle
    var stickyTotal = document.querySelector('#cart-sticky .cart-sticky__total strong');
    if (stickyTotal && totalEl) stickyTotal.textContent = type === 'havale' ? formatMoney(parseInt(totalEl.dataset.havale)) : formatMoney(parseInt(totalEl.dataset.card));

    // Cart attribute güncelle
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { payment_type: type } })
    }).catch(function() {});
  }
  window.selectPayment = selectPayment;

  /* ---------- goToCheckout ---------- */
  function goToCheckout(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var label = btn.textContent;
    btn.textContent = 'Hazırlanıyor...';
    btn.style.pointerEvents = 'none';

    var activeTab = document.querySelector('.cart-payment-tab.is-active');
    var paymentType = activeTab ? activeTab.dataset.payment : 'card';

    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var customer = null;
      try { customer = JSON.parse(localStorage.getItem('muyu_customer')); } catch(ex) {}

      var payload = {
        cart_token: cart.token || null,
        items: cart.items.map(function(item) {
          // final_line_price: Shopify otomatik indirimler dahil toplam satır fiyatı
          var effectivePrice = item.final_line_price != null
            ? (item.final_line_price / 100 / item.quantity)
            : (item.price / 100);
          return {
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {},
            title: item.product_title,
            variant_title: item.variant_title,
            price: effectivePrice,
            original_price: (item.price / 100),
            compare_at_price: COMPARE_PRICES[item.variant_id] ? (COMPARE_PRICES[item.variant_id] / 100) : null,
            image: item.image,
            product_type: item.product_type || ''
          };
        }),
        attributes: cart.attributes || {},
        note: cart.note || '',
        customer: customer,
        payment_type: paymentType,
        summary: CHECKOUT_SUMMARY,
        jid: window.muyuJid || null
      };

      return fetch(CHECKOUT_URL + '/api/checkout/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(r) { return r.json(); });
    }).then(function(data) {
      // ── begin_checkout tracking ──
      var mc = window.MUYU_CART || {};
      var total = (mc.price_total_cents || 0) / 100;
      if (typeof fbq !== 'undefined') fbq('track', 'InitiateCheckout', { value: total, currency: 'TRY', num_items: mc.item_count || 0 });
      if (typeof gtag !== 'undefined') gtag('event', 'begin_checkout', { currency: 'TRY', value: total });

      var checkoutUrl = CHECKOUT_URL + '/checkout?session_id=' + data.session_id;
      if (window.muyuJid) checkoutUrl += '&jid=' + window.muyuJid;
      window.location.href = checkoutUrl;
    }).catch(function(err) {
      btn.textContent = label;
      btn.style.pointerEvents = '';
      console.error('Checkout error:', err);
      alert('Hata: ' + err.message);
    });
  }
  window.goToCheckout = goToCheckout;

  /* ---------- updateTriggerSaved ---------- */
  function updateTriggerSaved(code) {
    var trigger = document.getElementById('save-cart-trigger');
    if (trigger) {
      trigger.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" style="vertical-align:-2px"><circle cx="8" cy="8" r="8" fill="#2ea818"/><path d="M10.67 5.33L6.57 9.43L5.33 8.19" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size:0.7rem;color:#999;margin-left:4px">' + code + '</span>';
      trigger.disabled = true;
      trigger.style.textDecoration = 'none';
      trigger.style.cursor = 'default';
      trigger.onclick = null;
    }
  }
  window.updateTriggerSaved = updateTriggerSaved;

  /* ---------- showPrintBtn ---------- */
  function showPrintBtn() {
    var printBtn = document.getElementById('cart-print-btn');
    if (printBtn) printBtn.style.display = 'inline';
  }
  window.showPrintBtn = showPrintBtn;

  /* ---------- printCart ---------- */
  function printCart() {
    var w = window.open('', '_blank');
    var items = '';
    var printItems = MC.printItems || [];

    printItems.forEach(function(pi) {
      items += '<tr><td style="padding:8px 0;border-bottom:1px solid #eee;font-size:14px;">' + pi.title + ' — ' + pi.variant;
      if (pi.gift) {
        var pCount = pi.is_double ? 2 : 1;
        var giftLower = (pi.gift || '').toLowerCase();
        if (giftLower.indexOf('bon') > -1) {
          items += '<br><span style="font-size:11px;color:#666;">Hediye: ' + pCount + ' BON+BON Visco Yastik</span>';
        } else {
          items += '<br><span style="font-size:11px;color:#666;">Hediye: Yorgan + ' + pCount + ' Microgel Yastik</span>';
        }
      }
      items += '</td><td style="padding:8px 0;border-bottom:1px solid #eee;text-align:center;font-size:14px;">' + pi.quantity + '</td><td style="padding:8px 0;border-bottom:1px solid #eee;text-align:right;font-size:14px;">' + pi.price_formatted + '</td></tr>';
    });

    var activeTab = document.querySelector('.cart-payment-tab.is-active');
    var paymentLabel = activeTab ? activeTab.querySelector('.cart-payment-tab__title').textContent : '';
    var totalEl = document.getElementById('total-display');
    var savingsEl = document.getElementById('savings-display');

    w.document.write('<html><head><title>Sepet Ozeti — Muyu</title></head><body style="font-family:Helvetica,Arial,sans-serif;max-width:600px;margin:40px auto;color:#1c1b1b;">');
    w.document.write('<div style="text-align:center;margin-bottom:24px;font:900 24px/1 Helvetica,Arial,sans-serif">Muyu</div>');
    var printCode = localStorage.getItem('cart_code') || '';
    w.document.write('<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:16px;"><h2 style="font-size:18px;margin:0;">Sepet Ozeti</h2><span style="font-size:12px;color:#999;">' + printCode + '</span></div>');
    w.document.write('<table width="100%" cellpadding="0" cellspacing="0"><thead><tr><th style="text-align:left;padding:8px 0;border-bottom:2px solid #1c1b1b;font-size:13px;">Urun</th><th style="text-align:center;padding:8px 0;border-bottom:2px solid #1c1b1b;font-size:13px;">Adet</th><th style="text-align:right;padding:8px 0;border-bottom:2px solid #1c1b1b;font-size:13px;">Fiyat</th></tr></thead><tbody>' + items + '</tbody></table>');
    w.document.write('<div style="margin-top:16px;padding-top:12px;border-top:2px solid #1c1b1b;display:flex;justify-content:space-between;font-size:16px;font-weight:700;"><span>Toplam</span><span>' + (totalEl ? totalEl.textContent : MC.price_total_formatted) + '</span></div>');
    if (savingsEl) w.document.write('<div style="margin-top:8px;font-size:13px;color:#2ea818;">Toplam indirim: ' + savingsEl.textContent + '</div>');
    w.document.write('<div style="margin-top:8px;font-size:13px;color:#666;">Odeme: ' + paymentLabel + '</div>');
    w.document.write('<div style="margin-top:24px;padding-top:16px;border-top:1px solid #eee;text-align:center;font-size:11px;color:#999;">100 Gece Deneme | 10 Yil Garanti | Ucretsiz Kargo | Kosulsuz Iade<br>muyusleep.com</div>');
    w.document.write('</body></html>');
    w.document.close();
    w.print();
  }
  window.printCart = printCart;

  /* ---------- saveCart (form submit) ---------- */
  function saveCart(e) {
    e.preventDefault();
    var form = document.getElementById('save-cart-form');
    var btn = document.getElementById('save-cart-submit');
    btn.textContent = 'Kaydediliyor...';
    btn.disabled = true;

    var activeTab = document.querySelector('.cart-payment-tab.is-active');
    var paymentType = activeTab ? activeTab.dataset.payment : 'card';

    var cartItems = MC.cartItems || [];

    var firstName = form.full_name.value.split(' ')[0];
    var lastName = form.full_name.value.split(' ').slice(1).join(' ');

    var cartTotal = MC.price_total_cents || 0;
    var havaleTotal = Math.round(cartTotal * 0.85);
    var finalTotal = paymentType === 'havale' ? havaleTotal : cartTotal;

    var compareTotal = MC.compare_total_cents || 0;
    var totalSavings = compareTotal - cartTotal;
    if (MC.has_mattress) totalSavings += (MC.gift_total_cents || 0);
    if (paymentType === 'havale') totalSavings += Math.round(cartTotal * 0.15);

    var trackProps = {
      cart_items: cartItems,
      cart_total: cartTotal,
      cart_total_formatted: formatMoney(cartTotal),
      compare_total_formatted: formatMoney(compareTotal),
      final_total: finalTotal,
      final_total_formatted: formatMoney(finalTotal),
      total_savings_formatted: formatMoney(totalSavings),
      havale_total_formatted: formatMoney(havaleTotal),
      payment_type: paymentType,
      payment_type_label: paymentType === 'havale' ? 'Havale / EFT (%15 indirim)' : 'Kredi Karti (6 taksit)',
      cart_url: 'https://checkout.muyusleep.com/checkout',
      item_count: MC.item_count || 0,
      customer_name: form.full_name.value,
      customer_email: form.email.value,
      customer_phone: form.phone.value,
      cart_code: localStorage.getItem('cart_code') || ''
    };

    trackProps.muyu_jid = window.muyuJid || null;

    var _learnq = window._learnq = window._learnq || [];
    _learnq.push(['identify', {
      $email: form.email.value,
      $first_name: firstName,
      $last_name: lastName,
      $phone_number: form.phone.value,
      $consent: ['email'],
      muyu_jid: window.muyuJid || null
    }]);
    _learnq.push(['track', 'Saved Cart', trackProps]);
    console.log('Klaviyo Saved Cart tracked (SDK)');

    // Backend'e (Supabase) kaydet — Pinpon V2 buradan okuyor
    if (window.muyuJid) {
      fetch('https://checkout.muyusleep.com/api/checkout/cart-saved', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jid: window.muyuJid,
          email: form.email.value,
          first_name: firstName,
          last_name: lastName,
          phone: form.phone.value,
          cart_items: cartItems,
          cart_total: cartTotal,
          payment_type: paymentType,
          cart_code: localStorage.getItem('cart_code') || ''
        })
      }).catch(function(){});
    }

    var discountCode = paymentType === 'havale' ? 'hvl15' : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: paymentType === 'havale' ? 'Havale/EFT ile ödeme' : '',
        attributes: {
          payment_type: paymentType,
          customer_name: form.full_name.value,
          customer_email: form.email.value,
          customer_phone: form.phone.value
        }
      })
    }).then(function() {
      var checkoutUrl = 'https://checkout.muyusleep.com/checkout';

      var abandonedUrl = checkoutUrl
        + (checkoutUrl.indexOf('?') > -1 ? '&' : '?')
        + 'checkout[email]=' + encodeURIComponent(form.email.value)
        + '&checkout[shipping_address][first_name]=' + encodeURIComponent(firstName)
        + '&checkout[shipping_address][last_name]=' + encodeURIComponent(lastName)
        + '&checkout[shipping_address][phone]=' + encodeURIComponent(form.phone.value);

      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = abandonedUrl;
      document.body.appendChild(iframe);

      setTimeout(function() {
        document.body.removeChild(iframe);
      }, 3000);

      console.log('Saved Cart URL tracked');

      form.style.display = 'none';
      document.getElementById('save-cart-success').style.display = 'block';

      var cartCode = localStorage.getItem('cart_code');
      if (!cartCode) {
        cartCode = Math.random().toString(36).substring(2,6).toUpperCase();
        localStorage.setItem('cart_code', cartCode);
      }
      updateTriggerSaved(cartCode);
      try { localStorage.setItem('cart_saved', '1'); } catch(ex) {}
      showPrintBtn();

      try {
        localStorage.setItem('muyu_customer', JSON.stringify({
          email: form.email.value,
          first_name: firstName,
          last_name: lastName,
          phone: form.phone.value
        }));
      } catch(ex) {}
    });

    return false;
  }
  window.saveCart = saveCart;

  /* ---------- saveCartAction ---------- */
  function saveCartAction() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('muyu_customer')); } catch(e) {}

    if (saved && saved.email) {
      quickSaveCart(saved);
    } else {
      document.getElementById('save-cart-modal').classList.add('is-open');
    }
  }
  window.saveCartAction = saveCartAction;

  /* ---------- quickSaveCart ---------- */
  function quickSaveCart(customer) {
    var trigger = document.getElementById('save-cart-trigger');
    trigger.textContent = 'Kaydediliyor...';
    trigger.disabled = true;

    var activeTab = document.querySelector('.cart-payment-tab.is-active');
    var paymentType = activeTab ? activeTab.dataset.payment : 'card';

    var cartItems = MC.cartItems || [];

    var cartTotal = MC.price_total_cents || 0;
    var havaleTotal = Math.round(cartTotal * 0.85);
    var finalTotal = paymentType === 'havale' ? havaleTotal : cartTotal;
    var compareTotal = MC.compare_total_cents || 0;
    var totalSavings = compareTotal - cartTotal;
    if (MC.has_mattress) totalSavings += (MC.gift_total_cents || 0);
    if (paymentType === 'havale') totalSavings += Math.round(cartTotal * 0.15);

    var quickProps = {
      cart_items: cartItems,
      cart_total: cartTotal,
      cart_total_formatted: formatMoney(cartTotal),
      compare_total_formatted: formatMoney(compareTotal),
      final_total: finalTotal,
      final_total_formatted: formatMoney(finalTotal),
      total_savings_formatted: formatMoney(totalSavings),
      havale_total_formatted: formatMoney(havaleTotal),
      payment_type: paymentType,
      payment_type_label: paymentType === 'havale' ? 'Havale / EFT (%15 indirim)' : 'Kredi Karti (6 taksit)',
      cart_url: 'https://checkout.muyusleep.com/checkout',
      item_count: MC.item_count || 0,
      customer_name: (customer.first_name || '') + ' ' + (customer.last_name || ''),
      customer_email: customer.email,
      customer_phone: customer.phone || '',
      cart_code: localStorage.getItem('cart_code') || '',
      muyu_jid: window.muyuJid || null
    };

    var _learnq = window._learnq = window._learnq || [];
    _learnq.push(['identify', {
      $email: customer.email,
      $first_name: customer.first_name,
      $last_name: customer.last_name,
      $phone_number: customer.phone,
      $consent: ['email'],
      muyu_jid: window.muyuJid || null
    }]);
    _learnq.push(['track', 'Saved Cart', quickProps]);
    console.log('Klaviyo Saved Cart tracked (SDK, quick)');

    // Backend'e (Supabase) kaydet — Pinpon V2 buradan okuyor
    if (window.muyuJid) {
      fetch('https://checkout.muyusleep.com/api/checkout/cart-saved', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jid: window.muyuJid,
          email: customer.email,
          first_name: customer.first_name,
          last_name: customer.last_name,
          phone: customer.phone,
          cart_items: cartItems,
          cart_total: cartTotal,
          payment_type: paymentType,
          cart_code: localStorage.getItem('cart_code') || ''
        })
      }).catch(function(){});
    }

    setTimeout(function() {
      var cartCode = localStorage.getItem('cart_code');
      if (!cartCode) {
        cartCode = Math.random().toString(36).substring(2,6).toUpperCase();
        localStorage.setItem('cart_code', cartCode);
      }
      updateTriggerSaved(cartCode);
      try { localStorage.setItem('cart_saved', '1'); } catch(ex) {}
      showPrintBtn();
    }, 500);
  }
  window.quickSaveCart = quickSaveCart;

  /* ---------- cartChanged ---------- */
  function cartChanged() {
    try {
      localStorage.removeItem('cart_saved');
      localStorage.removeItem('cart_code');
      sessionStorage.setItem('cart_timer', '600');
    } catch(e) {}
  }
  window.cartChanged = cartChanged;

  /* ---------- updateQty ---------- */
  /* ── AJAX cart refresh (no full page reload) ── */
  function refreshCartSection() {
    fetch('/cart?sections=main-cart').then(function(r) { return r.json(); }).then(function(data) {
      var html = data['main-cart'];
      if (!html) { window.location.reload(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newCart = tmp.querySelector('.cart-page');
      var oldCart = document.querySelector('.cart-page');
      if (newCart && oldCart) {
        oldCart.innerHTML = newCart.innerHTML;
      }
      // Header cart count güncelle
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('.Header__CartCount').forEach(function(el) { el.textContent = cart.item_count; });
      });
      // Active cart sinyali
      syncActiveCart();
      // Re-init: aktif ödeme tipini sticky bar'a uygula
      var activeTab = document.querySelector('.cart-payment-tab.is-active');
      if (activeTab) selectPayment(activeTab.dataset.payment);
    }).catch(function() { window.location.reload(); });
  }

  function updateQty(key, qty) {
    cartChanged();
    qty = Math.max(0, qty);
    var item = document.querySelector('[data-key="' + key + '"]');
    if (item) {
      if (qty === 0) {
        item.style.opacity = '0.15';
        item.style.transform = 'translateX(-20px)';
        item.style.transition = 'all 0.2s';
      } else {
        item.style.opacity = '0.4';
        item.style.transition = 'opacity 0.15s';
      }
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function() {
      refreshCartSection();
    });
  }
  window.updateQty = updateQty;

  /* ---------- switchModel ---------- */
  function switchModel(oldKey, newVariantId, qty) {
    cartChanged();
    var item = document.querySelector('[data-key="' + oldKey + '"]');
    if (item) { item.style.opacity = '0.3'; item.style.transition = 'opacity 0.2s'; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    }).then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(newVariantId), quantity: qty })
      });
    }).then(function() { refreshCartSection(); });
  }
  window.switchModel = switchModel;

  /* ---------- changeVariant ---------- */
  function changeVariant(oldKey, productId, newVariantId, qty) {
    cartChanged();
    var item = document.querySelector('[data-key="' + oldKey + '"]');
    if (item) { item.style.opacity = '0.3'; item.style.transition = 'opacity 0.2s'; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    }).then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(newVariantId), quantity: qty })
      });
    }).then(function() { refreshCartSection(); });
  }
  window.changeVariant = changeVariant;

  /* ── Add to cart (upsell) ── */
  function addToCart(variantId, btn) {
    var label = btn.textContent;
    btn.textContent = 'Ekleniyor...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function() {
      window.location.reload();
    }).catch(function() {
      btn.textContent = label;
      btn.disabled = false;
    });
  }
  window.addToCart = addToCart;

  /* ── Switch gift (change Hediye property) ── */
  function switchGift(itemKey, newGift) {
    // UI feedback — seçilen opsiyonu hemen göster
    var tooltip = document.querySelector('[data-key="' + itemKey + '"] .cart-gift-tooltip');
    if (tooltip) {
      tooltip.querySelectorAll('.cart-gift-opt').forEach(function(opt) {
        opt.classList.remove('is-selected');
        if (opt.textContent.indexOf(newGift === 'BON+BON Yastık' ? 'BON+BON' : 'Uyku Seti') > -1) {
          opt.classList.add('is-selected');
        }
      });
      tooltip.classList.remove('is-open');
    }

    // Ürün kartını loading state'e al
    var cartItem = document.querySelector('[data-key="' + itemKey + '"]');
    if (cartItem) {
      cartItem.style.opacity = '0.4';
      cartItem.style.pointerEvents = 'none';
      cartItem.style.transition = 'opacity 0.15s';
      // Gift text'i hemen güncelle
      var giftSpan = cartItem.querySelector('.cart-item__gift > span:not(.cart-item__gift-badge)');
      if (giftSpan) {
        giftSpan.textContent = 'Değiştiriliyor...';
      }
    }

    // Variant bilgisini HTML'den oku — /cart.js çağrısı yok, 1 istek tasarruf
    var el = document.querySelector('[data-key="' + itemKey + '"]');
    var variantId = parseInt(el.dataset.variantId);
    var qty = parseInt(el.dataset.qty);

    // Sil + ekle paralel değil ama ardışık (Shopify sıra istiyor)
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    }).then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties: { 'Hediye': newGift } })
      });
    }).then(function() {
      refreshCartSection();
    });
  }
  window.switchGift = switchGift;

  /* =====================================================
     Active cart tracker — syncActiveCart
     ===================================================== */
  function syncActiveCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      if (!cart.items || !cart.items.length) return;
      var customer = null;
      try { customer = JSON.parse(localStorage.getItem('muyu_customer')); } catch(e) {}

      fetch(CHECKOUT_URL + '/api/checkout/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'active_cart',
          cart_token: cart.token || null,
          items: cart.items.map(function(item) {
            return { variant_id: item.variant_id, quantity: item.quantity, title: item.product_title, variant_title: item.variant_title, price: item.price / 100, image: item.image, product_type: item.product_type || '', properties: item.properties || {} };
          }),
          customer: customer,
          brand: 'muyu',
          jid: window.muyuJid || null
        })
      }).catch(function() {});

      // ── Cart page tracking ──
      var cartTotal = cart.total_price / 100;
      var cartItems = cart.items.map(function(item) {
        return { id: String(item.variant_id), name: item.product_title, variant: item.variant_title, price: (item.price / 100).toFixed(2), quantity: item.quantity };
      });

      // Facebook — view_cart
      if (typeof fbq !== 'undefined') {
        fbq('track', 'ViewContent', {
          content_type: 'product',
          content_ids: cart.items.map(function(i) { return String(i.variant_id); }),
          value: cartTotal,
          currency: 'TRY',
          num_items: cart.item_count
        });
      }

      // GA4 — view_cart
      if (typeof gtag !== 'undefined') {
        gtag('event', 'view_cart', {
          currency: 'TRY',
          value: cartTotal,
          items: cartItems.map(function(i) { return { item_id: i.id, item_name: i.name, item_variant: i.variant, price: parseFloat(i.price), quantity: i.quantity }; })
        });
      }

    }).catch(function() {});
  }
  syncActiveCart();

  /* =====================================================
     IIFE: pageshow handler
     ===================================================== */
  window.addEventListener('pageshow', function() {
    ['checkout-btn', 'checkout-btn-sticky'].forEach(function(id) {
      var btn = document.getElementById(id);
      if (btn) { btn.textContent = 'Ödemeye geç'; btn.style.pointerEvents = ''; }
    });
  });

  /* Sticky bar: ödeme butonunu geçince göster */
  (function() {
    var checkoutBtn = document.getElementById('checkout-btn');
    var stickyBar = document.getElementById('cart-sticky');
    if (!checkoutBtn || !stickyBar) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(checkoutBtn);
  })();

  /* =====================================================
     IIFE: Cart saved check
     ===================================================== */
  (function(){
    try {
      if (localStorage.getItem('cart_saved')) {
        var cartCode = localStorage.getItem('cart_code') || '';
        updateTriggerSaved(cartCode);
        showPrintBtn();
      }
    } catch(e) {}
  })();

  /* =====================================================
     IIFE: Cart code + timer
     ===================================================== */
  (function(){
    var cartCode = localStorage.getItem('cart_code');
    if (!cartCode) {
      cartCode = Math.random().toString(36).substring(2,6).toUpperCase();
      localStorage.setItem('cart_code', cartCode);
    }
    var codeEl = document.getElementById('cart-code-display');
    if (codeEl) codeEl.textContent = cartCode + ' —';

    var display = document.getElementById('timer-display');
    if (!display) return;

    var savedCode = sessionStorage.getItem('cart_timer_code');
    var currentCode = localStorage.getItem('cart_code');
    var total = 600;

    if (savedCode && savedCode === currentCode) {
      var saved = sessionStorage.getItem('cart_timer');
      if (saved) total = Math.max(0, parseInt(saved));
    }

    sessionStorage.setItem('cart_timer_code', currentCode);

    var tick = setInterval(function(){
      total--;
      if (total <= 0) { clearInterval(tick); display.textContent = '0:00'; return; }
      var m = Math.floor(total / 60);
      var s = total % 60;
      display.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      sessionStorage.setItem('cart_timer', total);
    }, 1000);
  })();

  /* =====================================================
     IIFE: clear_data handler
     ===================================================== */
  (function(){
    if (new URLSearchParams(window.location.search).get('clear_data') === '1') {
      localStorage.clear();
      sessionStorage.clear();
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() { window.location.reload(); });
    }
  })();

  /* =====================================================
     IIFE: Review rotator
     ===================================================== */
  (function(){
    var db = {
      yatak: [
        ['Sırt ve omuz ağrılarım kesildi. Teşekkürler Muyu', 'Tolga Y.'],
        ['Sanki bulutlarda uyuyoruz, Muyu sen bir harikasın', 'Kubilay T.'],
        ['Muhteşem bir deneyim, aileme de alacağım en yakın zamanda', 'Tuğçe K.'],
        ['Yatak çok harika, kesinlikle tavsiye ediyorum', 'Mehmet G.'],
        ['İki çocuğuma aldım, ikisi de çok rahat ettiklerini söyledi', 'Ebru Ü.'],
        ['Beklentimizin üzerinde bir ürün geldi, gayet rahat ve kaliteli', 'Merkez S.'],
        ['2 geceden sonra sırt ağrılarım geçti, teşekkürler Muyu', 'Zeynep A.'],
        ['Hayatımda bu kadar güzel bir uyku deneyimi daha önce yaşamadım', 'Başak K.'],
        ['Konforlu uyku istiyorsanız tercihinizi Muyu dan yana kullanın', 'Fatih S.'],
        ['Oldukça konforlu ve kaliteli bir ürün, çok memnunum', 'Sercan S.'],
        ['Çok rahat ve uyumlu, vücudu sarıyor, ortopedik olması ayrıca güzel', 'Övünç A.'],
        ['Kargo sağlam ve hasarsız elime ulaştı, yatağı beğendim, tavsiye ederim', 'Birgül T.'],
        ['Kızım için aldım çok başarılı, çift kişilik de sipariş vereceğim', 'Yusuf A.'],
        ['Bel ağrım tamamen geçti, tek pişmanlığım daha önce almamış olmak', 'İclal Ş.'],
        ['Sağlıklı ve dinç bir uyku için Muyu seçin', 'Cenk C.']
      ],
      visco: [
        ['3. alışım, çok rahat, boyun ve baş ağrılarım azaldı', 'Bilge A.'],
        ['Boyun ağrılarım azaldı, rahat uyuyabildim', 'Şeyda P.'],
        ['Çok rahat kullanışlı bir yastık', 'Seyit A.'],
        ['Yastık anlatıldığı gibi gerçekten çok rahat', 'Zeki Y.'],
        ['Boyun ağrılarım için aldım, kesinlikle fark yarattı', 'Ahmet K.'],
        ['Harika bir yastık, uyku kalitem çok arttı', 'Derya T.'],
        ['İlk geceden farkı hissettim, boynum artık ağrımıyor', 'Murat S.']
      ],
      bonbon: [
        ['Harika bir yastık, bence yatak zaten apayrı bir güzel', 'Çiğdem A.'],
        ['Yastıklar baya kaliteli, yatağın yanında hediye geldi, çok iyi', 'Erkan A.'],
        ['Güzel, çok memnunuz. Teşekkürler Muyu', 'Ufuk U.'],
        ['Çok rahatlatıcı, teşekkür ederim', 'Ünsal A.'],
        ['Muhteşem marka, muhteşem ürünler', 'Yılmaz K.'],
        ['Yumuşacık ve serin, gece boyunca rahat uyuyorum', 'Elif B.'],
        ['Cooling effect gerçekten işe yarıyor, çok memnunum', 'Burak D.']
      ],
      bebek: [
        ['Oğluma 6 aylıkken aldık, uyku süresi arttı, çok rahat etti', 'Enis T.'],
        ['Kızım için aldım, en güvendiğim en rahat olanını tercih ettim', 'Yıldız Y.'],
        ['Kızım için aldığım yataktı ama biz de ayrılamaz olduk, çok rahat', 'Ülker C.'],
        ['10 aylık kızım için aldım, gayet memnun olduğunu düşünüyorum', 'Burak Ç.'],
        ['Rahat ve konforlu, bozulma yapmıyor, kaç yıldır kullanıyorum', 'Hakan N.']
      ],
      yorgan: [
        ['Çok hafif bir o kadar da sıcak tutan yorgan, yastıklar da yumuşacık', 'Uğur K.'],
        ['Artık sizin yorganı kullanıyoruz, hafif ve çok yeterli', 'Cenk C.'],
        ['Çok kaliteli ve kullanışlılar, yorganı daha çok beğendik', 'Ferhat A.'],
        ['Gerçekten mükemmel ötesi, memnun kaldım', 'Görkem S.'],
        ['Çok kaliteli, verilen parayı kesinlikle hak ediyor', 'Büşra K.']
      ],
      microgel: [
        ['O kadar rahat bir yastık ki tekrar alacağım, iyi ki Muyu', 'Pınar K.'],
        ['Çok hafif yastıklar, çok rahat', 'Cenk C.'],
        ['Yorgan ve yastık çok güzel, bu kadar güzel hediye için teşekkürler', 'Çağrı S.'],
        ['Yumuşacık ve hafif, uyku kalitemi artırdı', 'Ayşe D.'],
        ['Microgel yastık beklentimin üzerinde çıktı, çok memnunum', 'Mehmet K.']
      ]
    };

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
      return arr;
    }

    for (var key in db) shuffle(db[key]);

    var els = document.querySelectorAll('.cart-item__review[data-rv]');
    if (!els.length) return;

    var counters = [];
    els.forEach(function(el, idx) {
      var type = el.dataset.rvType || 'yatak';
      var list = db[type] || db.yatak;
      counters.push({ idx: idx % list.length, type: type });
      show(el, list[idx % list.length]);
      el.style.opacity = '1';
    });

    setInterval(function() {
      els.forEach(function(el, i) {
        var type = counters[i].type;
        var list = db[type] || db.yatak;
        el.style.opacity = '0';
        setTimeout(function() {
          counters[i].idx = (counters[i].idx + 1) % list.length;
          show(el, list[counters[i].idx]);
          el.style.opacity = '1';
        }, 400);
      });
    }, 5000);

    function show(el, rv) {
      el.querySelector('.cart-item__review-text').textContent = '"' + rv[0] + '"';
      el.querySelector('.cart-item__review-author').innerHTML = '— ' + rv[1] + ' <span class="cart-item__review-stars">★★★★★</span>';
    }
  })();

  /* Yorgan hediye yastık ekleme — theme.liquid intercept'inde yapılıyor */

  /* ---------- Otomatik Saved Cart (email cache'de varsa, sepet değiştiyse) ---------- */
  function autoFireSavedCart() {
    try {
      var raw = localStorage.getItem('muyu_customer');
      if (!raw) return;
      var customer = JSON.parse(raw);
      if (!customer || !customer.email) return;

      var itemCount = MC.item_count || 0;
      var cartTotal = MC.price_total_cents || 0;
      if (itemCount === 0) return;

      var hash = itemCount + '_' + cartTotal;
      var lastHash = localStorage.getItem('muyu_last_saved_cart_hash');
      if (lastHash === hash) return;

      if (typeof window.quickSaveCart === 'function') {
        window.quickSaveCart(customer);
        localStorage.setItem('muyu_last_saved_cart_hash', hash);
        console.log('Auto Saved Cart fired (hash: ' + hash + ')');
      }
    } catch(e) {}
  }
  window.autoFireSavedCart = autoFireSavedCart;

  /* İlk yüklemede _learnq yüklenmiş olmayabilir → biraz bekle */
  setTimeout(function() {
    autoFireSavedCart();
  }, 1500);

})();
